module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mode-box user-info"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-box"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "label-width": "125px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "邮箱:",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "readonly": true,
      "disabled": true
    },
    model: {
      value: (_vm.userInfo.email),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "email", $$v)
      },
      expression: "userInfo.email"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "昵称：",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "readonly": _vm.inforeadonly,
      "disabled": _vm.inforeadonly
    },
    model: {
      value: (_vm.userInfo.name),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "name", $$v)
      },
      expression: "userInfo.name"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModify),
      expression: "showModify"
    }],
    attrs: {
      "label": "新密码：",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "输入新密码,不填写代表不修改",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModify),
      expression: "showModify"
    }],
    attrs: {
      "label": " ",
      "label-width": "120px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.userInfo.name
    },
    on: {
      "click": _vm.saveInfo
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModify),
      expression: "showModify"
    }],
    attrs: {
      "label": " ",
      "label-width": "120px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "cancel"
    },
    on: {
      "click": _vm.toModify
    }
  }, [_vm._v("取消")])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inforeadonly),
      expression: "inforeadonly"
    }],
    attrs: {
      "label": " ",
      "label-width": "120px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.toModify
    }
  }, [_vm._v("修改")])], 1)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mode-box-hd"
  }, [_c('h2', [_c('i', {
    staticClass: "icon-aiUser"
  }), _vm._v("\n            个人信息\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5958131c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/userInfo.vue
// module id = 696
// module chunks = 1